module.exports = __webpack_public_path__ + "img/P150T_weapon_78.c5b48f49.png";